import { render, staticRenderFns } from "./panel-monitor-info.vue?vue&type=template&id=6da99b66&scoped=true"
import script from "./panel-monitor-info.vue?vue&type=script&lang=js"
export * from "./panel-monitor-info.vue?vue&type=script&lang=js"
import style0 from "./panel-monitor-info.vue?vue&type=style&index=0&id=6da99b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da99b66",
  null
  
)

export default component.exports